import React from 'react';

interface IProps {
  style?: any;
}

const CheckBoxIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" fill="none" viewBox="0 0 23 21">
      <rect width="22" height="20" x=".5" y=".5" stroke={props.style?.strokeColor ? props.style.strokeColor : "#204078"} rx="1.5"/>
      <path fill={props.style?.fillColor ? props.style.fillColor : "#204078"} d="M19 6.486L17.477 5l-8.245 8.045-3.71-3.62L4 10.911 9.219 16 19 6.486z"/>
    </svg>
  )
}

export default CheckBoxIcon;